import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SearchComment } from './searchResultComment.types';
import { camelToSnake } from '../../../../caseUtils';
import { Hyperlink } from '../../../../components/Hyperlink';
import { buildUrlWithParameters } from '../../../../utils/url-utils/urlUtils';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { withUser } from '../../../../user/UserContext';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { UserContextType } from '../../../../user/user.types';

type Props = {
  comment: SearchComment;
  originalQueryKey: string;
} & UserContextType &
  WithRestrictedModalProps;

const titleCharacterLimit = 125;

export class RawCommentedDecision extends React.Component<Props> {
  onClick = () => {
    const { accessPremium, openRestrictedModal } = this.props;
    if (!accessPremium) {
      openRestrictedModal('excerpt_results_comment_arret');
    } else {
      this.reportClick();
    }
  };

  onMouseDown = (event: { nativeEvent: MouseEvent & { which: number } }) => {
    const { accessPremium } = this.props;
    if (accessPremium && event.nativeEvent.which === 2) {
      this.reportClick();
    }
  };

  reportClick = () => {
    const { comment } = this.props;
    doctrineAnalytics('Search CommentaryDecisionClicked', {
      ...camelToSnake(comment),
      reportOriginalQueryKey: true,
    });
  };

  render() {
    const { comment, accessPremium, originalQueryKey } = this.props;
    const { arret } = comment;
    return (
      !!arret &&
      arret.searchTitle && (
        <div className="excerpt_comment__arret">
          <div className="excerpt_comment__arret__subtitle">
            <span className="excerpt_comment__arret__link__span">
              <FormattedMessage id="search/components/search-results/commentary/CommentedDecision.tsx/1" />
            </span>
            <Hyperlink
              className="excerpt_comment__arret__link"
              onClick={this.onClick}
              onMouseDown={this.onMouseDown}
              {...(accessPremium
                ? {
                    href: buildUrlWithParameters(arret.referenceUrl, {
                      source: 'excerpt_results_comment',
                      original_query_key: originalQueryKey,
                    }),
                  }
                : {})}
            >
              <span className="excerpt_comment__arret__link__title">
                {arret.searchTitle.substring(0, titleCharacterLimit)}{' '}
                {arret.searchTitle.length > titleCharacterLimit ? '...' : ''}
              </span>
            </Hyperlink>
          </div>
        </div>
      )
    );
  }
}

export const CommentedDecision = withUser(
  withRestrictedModal(RawCommentedDecision),
);
